import { Box, Typography, useTheme } from '@mui/material'
import { ReactElement } from 'react'

interface KeyValuePairProps {
    name: string
    value: string | number
}

/**
 * This component is written keeping in my the key value pairs shown in tooltip
 * @param param0
 * @returns
 */
const KeyValuePair = ({ name, value }: KeyValuePairProps): ReactElement => {
    const theme = useTheme()
    return (
        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
            <Typography
                variant="body2"
                fontWeight={theme.typography.fontWeightBold}
                fontSize={12}
            >
                {name}:&nbsp;
            </Typography>
            <Typography
                variant="body1"
                fontWeight={theme.typography.fontWeightRegular}
                fontSize={12}
            >
                {value}
            </Typography>
        </Box>
    )
}

export default KeyValuePair
